// extracted by mini-css-extract-plugin
export default {"action":"PersonalisedMenteeEmailersAddConfirmButton_action__EodWO"};